/**
 * Advanced Analytics API Client
 */

import { api } from '../api';
import { RFMScore, CustomerSegmentation, CohortAnalysis, MenuEngineering } from '../../types/analytics';

export interface AnalyticsParams {
  startDate?: string; // ISO date string
  endDate?: string; // ISO date string
}

export const advancedAnalyticsApi = {
  /**
   * Get RFM Analysis (Recency, Frequency, Monetary)
   */
  getRFMAnalysis: async (params?: AnalyticsParams): Promise<RFMScore[]> => {
    const { data } = await api.get<RFMScore[]>('/api/analytics/rfm', { params });
    return data;
  },

  /**
   * Get Customer Segmentation Analytics
   */
  getCustomerSegmentation: async (params?: AnalyticsParams): Promise<CustomerSegmentation> => {
    const { data } = await api.get<CustomerSegmentation>('/api/analytics/customer-segmentation', { params });
    return data;
  },

  /**
   * Get Cohort Analysis (Retention Matrix)
   */
  getCohortAnalysis: async (params?: AnalyticsParams): Promise<CohortAnalysis> => {
    const { data } = await api.get<CohortAnalysis>('/api/analytics/cohort-analysis', { params });
    return data;
  },

  /**
   * Get Menu Engineering Analysis (Stars, Plowhorses, Puzzles, Dogs)
   */
  getMenuEngineering: async (params?: AnalyticsParams): Promise<MenuEngineering> => {
    const { data } = await api.get<MenuEngineering>('/api/analytics/menu-engineering', { params });
    return data;
  },
};
